import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const cancelBookGroup = async (bookGroupId) => {
  try {
    await apiWrapper("DELETE", `book_groups/${bookGroupId}`);
    
    store.commit("ticketing/setbookGroup", null);
    store.commit("ticketing/setBook", []);
  } catch (err) {
    console.log('ERROR"" cancelBookGroup():', err);
    throw err;
  }
};
